import $ from 'jquery'
import _ from 'lodash'
import 'bootstrap'
import purify from './purify'

export default {
  init: function (elem, modal, yp, options) {
    _([elem, modal]).each(function (e, k) {
      if (e === undefined || e === null) {
        console.log('multilanguagepopup:init missing parameter ' + k + ' must be set')
      }
    })
    var D = {}
    var _options = $.extend({ PURIFY_MSG_DATA: true }, options)

    D.elem = $(elem)
    D.modal = modal
    return {
      successCallback: function (response) {
        $dialog = $('.modal-dialog', modal)
        $content = $('.modal-content', $dialog)
        var $tabpanel = $('<div>').attr('role', 'tabpanel')
        var $tabs = $('<ul>')
          .addClass('nav')
          .addClass('nav-tabs')
          .attr('role', 'tablist')
          .appendTo($tabpanel)
        var $tabpanes = $('<div>')
          .addClass('tab-content')
          .appendTo($tabpanel)

        var i = 0
        console.log(response.data.subject)
        _(response.data.langOrder).each(function (l) {
          l = l.replace(/[^a-zA-Z_-]/g, '')
          var subject = response.data.subject[l]
          var $tab = $('<li>')
            .attr('role', 'presentation')
            .html('<a href="#' + l + '" aria-controls="' + l +
              '" role="tab" data-toggle="tab">' + l + '</a>')
            .appendTo($tabs)
          var $tabcontent = $('<div>')
            .addClass('tab-pane')
            .attr('role', 'tabpanel')
            .attr('id', l)

          var $tos = $('<div class="to">')
          $tos.text(response.data.recipientsLabel[l])
          $('<div class="to-text">').text(response.data.recipients[l].join(', ')).appendTo($tos)
          $tos.appendTo($tabcontent)

          var $subjects = $('<div class="subject">')
          $subjects.text(response.data.subjectLabel[l])
          $('<div class="subject-text">').html(subject).appendTo($subjects)
          $subjects.appendTo($tabcontent)

          var $iframe = $(
            $.unsafeParseHTML(
              '<iframe src frameborder="0" style="width: 100%; height: 400px;">'))
            .appendTo($tabcontent)

          $iframe.load(function (e) {
            var doc = $iframe[0].contentWindow.document
            doc.open()
            var text = response.data.message[l]
            if (!_.isEmpty(text) && _options.PURIFY_MSG_DATA) {
              text = purify.run(text, { WHOLE_DOCUMENT: true })
            }
            doc.write(text)
            doc.close
          })
          $tabcontent.appendTo($tabpanes)
          if (i === 0) {
            $tab.addClass('active')
            $tabcontent.addClass('active')
          }
          i++
        })
        $content.append(
          '<div class="modal-header">' +
          '<button type="button" class="close" data-dismiss="modal">' +
          '<span aria-hidden="true">&times;</span>' +
          '<span class="sr-only">Close</span>' +
          '</button>' +
          '<h4 class="modal-title">' + D.elem.data('title') + '</h4>' +
          '</div>')
        $('<div>').addClass('modal-body').html($tabpanel).appendTo($content)
        $dialog.addClass('modal-lg')
        D.modal.one('show.bs.modal', function (e) {
          console.log('multilanguagepopup modal loaded')
          installHandlers(D.modal)
        }).one('hidden.bs.modal', function (e) {
          $content.empty()
          D.modal.data('bs.modal', null)
          $dialog.removeClass('modal-lg')
        })
          .modal({
            backdrop: 'static',
            show: true,
          })
          .data('who', D.modal)
      },
    }
  },
}
